module.exports = __webpack_public_path__ + "static/media/overline.428c6a99.svg";